import { useParams } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { LEGAL } from "../constants/legal";
import { Printer } from "lucide-react";

/**
 * Documento legal en página propia, con URL estable (/terms, /privacy).
 * El estudio necesita poder enlazarlo e imprimirlo para el registro de
 * Health Studio en Florida, por eso existe además del modal del footer.
 */
export default function Legal({ docKey }) {
  const { lang } = useLang();
  const params = useParams();
  const key = docKey || params.doc || "terms";
  const doc = (LEGAL[key] || LEGAL.terms)[lang] || LEGAL.terms.es;

  return (
    <main className="pt-32 pb-24 px-6 md:px-16 min-h-screen" data-testid={`legal-page-${key}`}>
      <div className="max-w-3xl mx-auto">
        <div className="flex items-start justify-between gap-6 flex-wrap">
          <div>
            <h1 className="font-serif text-3xl md:text-5xl text-white leading-tight">{doc.title}</h1>
            <p className="mt-3 text-[0.7rem] uppercase tracking-[0.3em] text-[#C5A059]">{doc.updated}</p>
          </div>
          <button
            onClick={() => window.print()}
            data-testid="legal-print"
            className="print:hidden inline-flex items-center gap-2 border border-[#C5A059]/40 px-5 py-3 text-[0.65rem] uppercase tracking-[0.25em] text-[#C5A059] hover:bg-[#C5A059]/10 transition-colors"
          >
            <Printer size={15} />
            {lang === "es" ? "Imprimir / PDF" : "Print / PDF"}
          </button>
        </div>

        <div className="mt-14 space-y-9">
          {doc.sections.map((s, i) => (
            <section key={i}>
              <h2 className="font-serif text-lg md:text-xl text-[#C5A059] italic">{s.h}</h2>
              <p className="mt-3 text-sm md:text-[0.95rem] text-zinc-300 font-light leading-relaxed whitespace-pre-line">
                {s.body}
              </p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
